import styled from '@emotion/styled'
import React from 'react'
import BreakPoints from '../../styles/breakPoints'
import ColumnH1 from '../atoms/columnH1'
import Introduction004 from './Introduction004'
import Introduction005 from './Introduction005'
import Introduction006 from './Introduction006'
import Introduction007 from './Introduction007'
import Introduction008 from './Introduction008'
import Introduction009 from './Introduction009'
import Introduction010 from './Introduction010'
import Introduction011 from './Introduction011'
import Introduction012 from './Introduction012'

const Wrapper = styled.article`
  position: relative;
  margin-bottom: 30px;

  .p-txt-date {
    margin-top: -10px;
    color: #ababab;
  }

  section {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    font-size: 16px;
    color: #505050;
    line-height: 1.6em;

    h1 {
      color: #414141;
      font-size: 22px;
      line-height: 1.4em;
      background: #f5f5f5;
      border-radius: 3px;
      position: relative;
      width: 100%;
      padding: 5px 5px 5px 20px;
      margin-bottom: 30px;
      margin-top: 10px;

      &:before {
        content: '';
        position: absolute;
        width: 10px;
        background: #77d7c9;
        left: 0;
        top: 0;
        border-radius: 3px 0 0 3px;
        height: 100%;
      }
    }

    h2 {
      color: #414141;
      font-size: 22px;
      line-height: 1.4em;
      background: #ffffff;
      border-radius: 3px;
      position: relative;
      width: 100%;
      padding: 5px 5px 5px 20px;
      margin-top: 10px;
      margin-bottom: 30px;

      &:before {
        content: '';
        position: absolute;
        width: 10px;
        background: #d8d8d8;
        left: 0;
        top: 0;
        border-radius: 3px 0 0 3px;
        height: 100%;
      }
    }

    h3 {
      color: #414141;
      font-size: 16px;
      line-height: 1.4em;
      background: #ffffff;
      width: auto;
      padding: 10px 0 8px;
      margin-top: -10px;
      margin-bottom: 20px;
      border-top: solid 2px #e5e5e5;
      border-bottom: solid 2px #e5e5e5;
    }

    p {
      padding-bottom: 30px;
      line-height: 2;
      position: relative;

      span {
        background: linear-gradient(transparent 60%, #ff6 60%);
        font-weight: 600;
      }

      .p-list-link {
        position: absolute;
        top: 6px;
        right: 2px;

        &:before {
          display: block;
          content: '';
          position: absolute;
          width: 0;
          height: 0;
          top: 7px;
          left: -14px;
          border-left: 8px solid #3ec7b3;
          border-top: 4px solid transparent;
          border-bottom: 4px solid transparent;
        }
      }

      &.txt-color-red {
        color: #ff6969;
      }
    }

    .link-div {
      width: 100%;
      display: flex;
      justify-content: left;
      padding-bottom: 30px;

      > div {
        width: 50px;
      }

      .link-p {
        width: calc(100% - 50px);

        .p-list-link {
          position: absolute;
          top: -3px;
          left: 30px;

          &:before {
            display: block;
            content: '';
            position: absolute;
            width: 0;
            height: 0;
            top: 11px;
            left: -14px;
            border-left: 8px solid #3ec7b3;
            border-top: 4px solid transparent;
            border-bottom: 4px solid transparent;
          }
        }
      }
    }

    img {
      width: 100%;
      height: auto;
      padding-bottom: 30px;
    }
  }

  ${BreakPoints.large} {
  }
`
type Props = {
  /** 広告の番号 */
  no: number
}

/**
 * コラム記事詳細：記事本体
 * @constructor
 */
const ColumnDetailInner0082 = (props: Props): JSX.Element => (
  <Wrapper>
    <ColumnH1 label="打刻忘れ対策について。問題点、忘れた時の対処法は？" />
    {/** TODO 川上申し送り事項：▼投稿日をここに表示 */}
    <p className="p-txt-date">2025.07.17</p>
    <section>
      {/** TODO 川上申し送り事項：▼記事投稿（？）で作成された内容がここに入る予定 */}
      <p>
        法律上、企業としては雇用する労働者の出退勤管理は必須となります。ひとえに出退勤管理と言っても現在では様々なツールが選択肢にあります。他方、利便性が高いゆえに労働者自身に任せていると打刻の失念や二重打刻等の「イレギュラー」が発生します。今回はその中でも打刻忘れ対策として行うべきことに注視し、解説します。
      </p>
      <img src="/images/column/details/c0082.jpg" alt="キンクラコラム画像82" />
      <div id="toc1">
        <h1>そもそもなぜ打刻忘れが起こるのか？</h1>
      </div>
      <p>
        「そもそもなぜ打刻忘れが起こるのか」の原因を究明する際に、よくある事例として「本人の責任感の問題」で片付けてしまうことです。もちろんそれも一つの原因ではあるでしょう。ただし、当人に対して上長から一度注意しても（以前より頻度は減るにしても）また以前のように戻る原因としては、
        <span>打刻の重要度を認識していないから</span>
        です。特にこの傾向が多いのは（もちろん全てのケースで当てはまるというわけではありませんが）月給者です。考えられる理由として時給者の場合は労働時間が賃金と密接に連動するのに対して、原則的な月給者の場合は、月の所定労働時間に対して予め給与が決まっているため、時給者と比べて打刻時間が賃金に紐づくという意識が希薄なケースに多く遭遇します。
        <br />
        <br />
        もちろん遅刻や早退があった場合にはノーワークノーペイの原則に則り、賃金の控除が行われますが、時間単位の有給休暇が制度として運用されている企業で、当日にも当該時間単位の有給休暇申請を認めている場合は、事実上、賃金の控除は行われないこととなります。
        <br />
        また、前提として労働時間管理は企業の責務であり、多くの場合、労働者自身に打刻を委ねているケースがあることは否定できませんが、杜撰な状態（例えば打刻忘れが頻発している）ですと企業も責任を負うこととなるため、より広い意味で打刻に関して意識を高めてもらうべく諭していく姿勢が重要です。
      </p>

      <div id="toc2">
        <h1>打刻忘れによる問題点</h1>
      </div>
      <p>
        言うまでもなく正確な賃金計算ができないことです。打刻時間は賃金とも紐づくもので、
        <span>
          時給制で契約する労働者の場合は打刻忘れが頻発している場合、正確な賃金計算（少なくとも支給項目については）は極めて困難
        </span>
        です。また、長時間労働に起因する労災事故が起きた場合、恒常的な打刻忘れが起きていると、どの程度の長時間労働に陥っていたのかの判別がつかず、労災請求にあたっても非常に手間と時間を要することになります。
      </p>

      {/** ここに9パターンの広告設定する */}
      {props.no === 0 && <Introduction004 />}
      {props.no === 1 && <Introduction005 />}
      {props.no === 2 && <Introduction006 />}
      {props.no === 3 && <Introduction007 />}
      {props.no === 4 && <Introduction008 />}
      {props.no === 5 && <Introduction009 />}
      {props.no === 6 && <Introduction010 />}
      {props.no === 7 && <Introduction011 />}
      {props.no === 8 && <Introduction012 />}

      <div id="toc3">
        <h1>打刻忘れの対策方法</h1>
      </div>
      <p>
        もちろん事業主トップからの啓蒙によって労働者自身が自分事と捉え、打刻忘れが減ることがあります。ただし、全ての労働者にこの効果があるとは考え難く、また、人は時間の経過とともに忘却するという特徴があるため、ある程度システマティックに対策を練る方が効果的です。例えば
        <span>
          始業時刻を経過しているにも関わらず打刻がない場合はPC端末にワーニングが表示される
        </span>
        のは一つの選択肢になり得ます。問題点として、直行直帰の場合はどうするのかという問題がありますが、費用的な問題がクリアできるのであればスマートフォンに通知を送る等が考えられますが、まずは多くの労働者が対象になり得る「対面」での問題をクリアしたのちに対策を練るのが有効でしょう。
        <br />
        <br />
        次に、
        <span>打刻忘れがある状態のままでは給与計算を締められない設計</span>
        にすることです。もちろん給与担当部門には負担がいく選択肢にはなりますが、他の部門に迷惑がかかるという状態に持っていくことでより本腰を入れて考えさせることができると言えます。ただし、（他のことにも言えますが）締め切り日を設けておかなければ効果は半減すると言えます。
      </p>

      <div id="toc4">
        <h1>忘れた場合の対処方法</h1>
      </div>
      <p>
        実務上、類推した時間を直接入力等することが考えられます。あくまで「類推」ですので、大なり小なり多少のずれが見込まれることから本来は褒められる対処方法ではありません。だからと言って空欄のままとすることは適切でなく、何らかの形で出退勤時刻を記載しておくことが求められます。また、企業が主導で対応することは相応しくなく、本人主導（そもそも本人以外知り得ないことが多い）で進めていくことが適切です。
        <br />
        <br />
        また、忘れた場合、対処の実行と並行し、原因の特定も必要です。常態的に打刻忘れが起こること自体、適切な状態ではなく、導線や施設設計に問題があるのか（例えば打刻端末に複数名の労働者が滞留してしまい打刻を後回しにする）等が考えられます。その場合は、費用負担は発生するものの端末機器の増設のみで解決してしまうこともあります。また、個々のPCからログインできるのであればその方法でも解決してしまうことがあります。
      </p>

      <div id="toc5">
        <h1>最後に</h1>
      </div>
      <p>
        打刻忘れは決して褒められるものではありませんが、施設設計上の問題や打刻手法（アナログからデジタル移行）の変更で容易に解決することが少なくありません。また、打刻忘れは賃金に紐づくことと、企業の責務として労働時間管理が必要であることを諭すことで打刻忘れ「常習者」も本腰を入れてより自分事と捉え、解決に向けた行動を取る場合があります。
      </p>
    </section>
  </Wrapper>
)

export default ColumnDetailInner0082
